import React, { useEffect, useState, useCallback } from 'react';
// Icons
import {
  ArrowBack as ArrowLeft,
  Close as X,
  CheckCircle,
  AccessTime as Clock,
  Description as FileText,
  Visibility as Eye,
  ThumbUp as ThumbUpIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Videocam as Video,
  Phone as PhoneIcon,
  LocationOn as MapPin,
  ArrowBack as ArrowBackIcon,
  Delete as DeleteIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import Alert from '@mui/material/Alert';
import SearchIcon from '@mui/icons-material/Search';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import Cancel from '@mui/icons-material/Cancel';
import VideoCallIcon from '@mui/icons-material/VideoCall';


import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
// MUI Components
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Avatar,
  Rating,
  Stack,
  Badge,
  InputAdornment,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { listAppointments, cancelAppointment } from "../../service/appointment";
import { useNavigate } from 'react-router-dom';
import { getReviewByAppointmentId, addReview, updateReview, deleteReview } from '../../service/review';
import { initiateIVRCall } from "../../service/ivr";


const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#FFD700',
  },
  '& .MuiRating-iconHover': {
    color: '#FFED85',
  },
});

const MyAppointments = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

  const navigate = useNavigate();

  // Typography styles with Inter font
  const typographyStyles = {
    fontFamily: theme.typography.fontFamily,
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 600,
    },
    '& button, & .MuiButton-root': {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
    },
    '& .MuiTypography-root': {
      fontFamily: theme.typography.fontFamily,
    }
  };

  const [activeTab, setActiveTab] = useState(0);
  const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
  const [copiedAppointmentId, setCopiedAppointmentId] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [feedbackTab, setFeedbackTab] = useState(0);
  const [canCancel, setCanCancel] = useState(true);
const [cancelRemark, setCancelRemark] = useState('');
  const [rating, setRating] = useState(0);
  const [feedbackTags, setFeedbackTags] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [review, setReview] = useState('');
  const [recommend, setRecommend] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' // 'success' | 'error' | 'info' | 'warning'
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');
  const [appointments, setAppointments] = useState([]);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);
  const [reviews, setReviews] = useState({});
  const [isLoadingReview, setIsLoadingReview] = useState(false);
  const [editingReview, setEditingReview] = useState(false);
  const [activeFilter, setActiveFilter] = useState(null); // 'pending-feedback' | 'completed' | null

  // Debug effect for activeFilter
  useEffect(() => {
    console.log('activeFilter changed:', activeFilter);
  }, [activeFilter]);

  const formatCancelledAt = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString); // must be a proper ISO string with Z/offset

    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",   // <-- do the conversion here, not manually
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const fetchAppointments = async () => {
    try {
      const data = await listAppointments(userId);
      console.log("Appointments API raw data:", data);
      console.log("Appointments count:", data?.length);

      const appointmentsArray = Array.isArray(data)
  ? data
  : data?.data || [];
  console.log("RAW API RESPONSE:", data);

console.log(
  "IS ARRAY:",
  Array.isArray(data)
);

console.log(
  "appointmentsArray:",
  appointmentsArray
);

console.log(
  "appointmentsArray length:",
  appointmentsArray.length
);

 const mapped = appointmentsArray.map(appt => {
  const appUserId = appt?.app_user_id || "";
  const isFamilyMember = appUserId.includes("-");

  const hasSlot = !!(appt?.slot_date && appt?.start_time && appt?.end_time);

  return {
    id: appt?.id,
    doctorName: appt?.doctor_name || `Dr. ${appt?.doctor_id}`,
    specialty: appt?.specialty || "General",
    hospital: appt?.hospital || "Hospital Name",
    date: appt?.slot_date
      ? new Date(appt.slot_date).toLocaleDateString("en-GB", {
          day: "numeric", month: "short", year: "numeric",
        })
      : "N/A",
    time: hasSlot
      ? `${appt.start_time.slice(0, 5)} - ${appt.end_time.slice(0, 5)}`
      : "N/A",
    type: appt?.consultation_type,
    status: appt?.status,
    avatar: appt?.avatar || "",
    meetLink: appt?.meet_link,
    doctor_id: appt?.doctor_id,
    customer_id: appt?.customer_id,
    rawDate: appt?.slot_date || null,       // null, not undefined-that-crashes-later
    startTime: appt?.start_time || null,
    customerName: appt?.customer_name || "Unknown",
    appUserId: appUserId,
    consultingFor: isFamilyMember ? "Family Member" : "Self",
    cancelledBy: appt?.cancellation_triggered_by,
    cancelledAt: appt?.cancelled_at,
    cancellationRemark: appt?.cancellation_remark,
    cancellationTriggeredBy: appt?.cancellation_triggered_by,
  };
});


      setAppointments(mapped);
    } catch (error) {
      console.error("Failed to fetch appointments:", error);
    }
  };

  useEffect(() => {
    if (userId) fetchAppointments();
  }, [userId]);

 console.log("selectedAppointment", selectedAppointment)

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const now = new Date();
  const isMoreThan2HoursBefore = (startTime, slotDate) => {
    if (!startTime || !slotDate) return false;

    const now = new Date();

   
    const appointmentDateTime = new Date(
      `${slotDate.split("T")[0]}T${startTime}`
    );

    const diff = appointmentDateTime - now;

    const TWO_HOURS = 2 * 60 * 60 * 1000;

    return diff > TWO_HOURS; // ✅ true = show cancel
  };


 const handleCancelClick = (appointment) => {
  const canCancel = isMoreThan2HoursBefore(
    appointment.startTime,
    appointment.rawDate
  );

  setAppointmentToCancel(appointment);
  setCanCancel(canCancel);
  setCancelDialogOpen(true);
};

 const handleCancelDialogClose = () => {
  setCancelDialogOpen(false);
  setAppointmentToCancel(null);
  setCancelRemark('');
};

const handleConfirmCancel = async () => {
  if (!appointmentToCancel) return;

  try {
    // Call the cancel appointment API with remark
    await cancelAppointment(appointmentToCancel.id, cancelRemark, 'echobuddy');
    setShowSnackbar({
      open: true,
      message: 'Appointment cancelled successfully',
      severity: 'success'
    });
    // Refresh the appointments list
    fetchAppointments();
  } catch (error) {
    console.error('Failed to cancel appointment:', error);
    setShowSnackbar({
      open: true,
      message: 'Failed to cancel appointment',
      severity: 'error'
    });
  } finally {
    handleCancelDialogClose();
  }
};
const upcomingAppointments = appointments?.filter((appt) => {
  const statusLower = appt.status?.toLowerCase().trim();

  if (statusLower !== "scheduled") return false;
  if (!appt.rawDate || !appt.startTime) return false;

  const appointmentDateTime = new Date(
    `${appt.rawDate.split("T")[0]}T${appt.startTime}`
  );

  return appointmentDateTime >= new Date();
});
   const scheduledAppointments = appointments?.filter((appt) => {
    if (appt.status?.toLowerCase() !== "scheduled") return false;
    if (!appt.rawDate || !appt.startTime) return false;

    const appointmentDate = new Date(
      `${appt.rawDate.split("T")[0]}T00:00:00`
    );

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return appointmentDate.getTime() === today.getTime();
  });

  const pastAppointments = appointments?.filter((appt) => {
  if (!appt.rawDate || !appt.startTime) return false;   // <-- add this
  const apptDateTime = new Date(`${appt.rawDate.split("T")[0]}T${appt.startTime}`);
  const statusLower = appt.status?.toLowerCase().trim();
  return apptDateTime < now && (statusLower === 'completed' || statusLower === 'not attended' || statusLower === 'cancelled');
});

  let filteredAppointments = activeTab === 0 ? upcomingAppointments : pastAppointments;

  // Debug logging
  console.log('Active Tab:', activeTab, 'Active Filter:', activeFilter);
  console.log('All appointments:', appointments);
  console.log('All appointment statuses:', appointments?.map(a => ({ id: a.id, status: a.status })));
  console.log('Past appointments:', pastAppointments);
  console.log('Upcoming appointments:', upcomingAppointments);
  console.log('Reviews:', reviews);

  // Apply additional filtering for the Past tab based on activeFilter
   if (activeTab === 1) {
    if (activeFilter === 'scheduled') {
      filteredAppointments = scheduledAppointments;
    } else if (activeFilter === 'pending-feedback') {
      const pendingFeedback = pastAppointments.filter(appt => {
        const hasNoReview = !reviews[appt.id];
        const isBooked = appt.status?.toLowerCase().trim() === 'booked' || appt.status?.toLowerCase().trim() === 'completed';
        console.log('Appointment:', appt.id, 'Status:', appt.status, 'Has Review:', !hasNoReview, 'Is Booked:', isBooked, 'Review:', reviews[appt.id]);
        return hasNoReview && isBooked;
      });
      console.log('Pending Feedback Appointments:', pendingFeedback);
      filteredAppointments = pendingFeedback;
    } else if (activeFilter === 'completed') {
      filteredAppointments = pastAppointments.filter(appt =>
        reviews[appt.id]
      );
    }
    // else if (activeFilter === 'cancelled') {
    //   filteredAppointments = appointments.filter(appt =>
    //     appt.status?.toLowerCase().trim() === 'cancelled'
    //   );
    // }
    else if (activeFilter === "cancelled") {
      filteredAppointments = appointments
        .filter(appt => appt.status?.toLowerCase() === "cancelled")
        .sort((a, b) => {
          const dateA = a.cancelledAt ? new Date(a.cancelledAt).getTime() : 0;
          const dateB = b.cancelledAt ? new Date(b.cancelledAt).getTime() : 0;
          return dateB - dateA;
        });
    }
  }

  const formatSlotToAMPM = (slot) => {
    if (!slot) return ""; // safety check

    const [start, end] = slot.split("-").map(s => s.trim()); // split by '-' and remove spaces
    if (!start || !end) return slot; // fallback if malformed

    const formatTime = (time24) => {
      const [hourStr, minute] = time24.split(":");
      let hour = parseInt(hourStr, 10);
      const ampm = hour >= 12 ? "PM" : "AM";
      hour = hour % 12;
      if (hour === 0) hour = 12;
      return `${hour}:${minute} ${ampm}`;
    };

    return `${formatTime(start)} - ${formatTime(end)}`;
  };

  const finalFilteredAppointments = filteredAppointments.filter((appt) => {
    const formattedTime = formatSlotToAMPM(appt.time);

    return (
      appt.doctorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.specialty.toLowerCase().includes(searchTerm.toLowerCase()) ||
      formattedTime.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appt.time.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const getTypeIcon = (type) => {
    const iconStyle = { fontSize: '1rem' };
    switch (type) {
      case 'Video Consultation': return <Video style={iconStyle} />;
      case 'Phone Call': return <PhoneIcon style={iconStyle} />;
      case 'In-Person': return <MapPin style={iconStyle} />;
      default: return <FileText style={iconStyle} />;
    }
  };

  const feedbackTagOptions = [
    'Helpful', 'Good Listener', 'Professional', 'Knowledgeable',
    'Empathetic', 'Thorough', 'Punctual', 'Clear Communication'
  ];

  const handleFeedbackTagToggle = (tag) => {
    setFeedbackTags(prev =>
      prev.includes(tag)
        ? prev.filter(t => t !== tag)
        : [...prev, tag]
    );
  };

  const handleEditReview = async (appointment) => {
    setSelectedAppointment(appointment);

    try {
      // Force fetch the latest review data
      const existingReview = await getReviewByAppointmentId(appointment.id);

      if (existingReview) {
        // Set all form fields with the fetched data
        setRating(existingReview?.data?.ratings || 0);
        setReview(existingReview?.data?.notes || '');
        setRecommend(existingReview?.data?.is_recommended ? 'yes' : 'no');
        setFeedbackTags(existingReview?.data?.experience || '')
        setEditingReview(true)
      } else {
        // If no review found, reset to new review state
        setRating(0);
        setReview('');
        setRecommend(null);
        setEditingReview(false);
      }

      // Only open the dialog after state is updated
      setOpenFeedbackDialog(true);
      setFeedbackTab(1);
    } catch (error) {
      console.error('Error fetching review:', error);
      // Still open dialog but in a clean state
      setRating(0);
      setReview('');
      setRecommend(null);
      setEditingReview(false);
      setOpenFeedbackDialog(true);
      setFeedbackTab(1);
    }
  };


  const handleDeleteAppointment = async (appointment) => {
    if (!appointment?.id) {
      console.error("Appointment ID not found");
      return;
    }

    // ✅ Show confirmation first
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this appointment?"
    );
    if (!confirmDelete) return; // User clicked "Cancel"

    try {
      // You can pass any data you want to update for deletion
      const data = { status: 'cancelled', app_name: 'EchoBuddy' };
      const res = await deleteAppointment(appointment.id, data);

      console.log('Appointment deleted/updated:', res);

      // ✅ Show success alert
      alert("Appointment deleted successfully");

      // Optional: refresh the appointments list
      fetchAppointments(); // or your function to reload
    } catch (err) {
      console.error('Failed to delete appointment:', err);
      const errorMsg = err?.message || 'Failed to delete appointment';
      alert(errorMsg);
    }
  };


  const handleDeleteReview = async (appointment) => {
    if (!window.confirm('Are you sure you want to delete your review?')) {
      return;
    }

    setIsLoadingReview(true);

    try {
      await deleteReview(appointment.id);

      // Update the reviews state to remove the deleted review
      setReviews(prev => {
        const newReviews = { ...prev };
        delete newReviews[appointment.id];
        return newReviews;
      });

      // Show success message
      setShowSnackbar({
        open: true,
        message: 'Review deleted successfully',
        severity: 'success'
      });
    } catch (error) {
      console.error('Error deleting review:', error);
      setShowSnackbar({
        open: true,
        message: 'Failed to delete review',
        severity: 'error'
      });
    } finally {
      setIsLoadingReview(false);
    }
  };

  const fetchReview = useCallback(async (appointmentId) => {
    if (!appointmentId) return null;

    try {
      const review = await getReviewByAppointmentId(appointmentId);
      setReviews(prev => ({
        ...prev,
        [appointmentId]: review
      }));
      return review;
    } catch (error) {
      console.error('Error fetching review:', error);
      return null;
    }
  }, []);

  useEffect(() => {
    const loadReviews = async () => {
      const reviewsMap = {};

      for (const appt of appointments) {
        if (appt.status === 'completed') {
          const review = await fetchReview(appt.id);
          if (review) {
            reviewsMap[appt.id] = review;
          }
        }
      }

      setReviews(reviewsMap);
    };

    if (appointments.length > 0) {
      loadReviews();
    }
  }, [appointments, fetchReview]);



  const handleSubmitFeedback = async () => {
    if (!selectedAppointment || !rating || recommend === null) return;

    setIsLoadingReview(true);
    console.log("feedbackTags", feedbackTags)

    try {
      const reviewData = {
        appointment_id: selectedAppointment.id,
        ratings: rating,
        notes: review,
        experience: feedbackTags,
        is_recommended: recommend === 'yes'
      };


      let result;
      if (editingReview) {
        result = await updateReview(selectedAppointment.id, reviewData);
      } else {
        result = await addReview(reviewData);
      }

      setReviews(prev => ({
        ...prev,
        [selectedAppointment.id]: result
      }));

      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
        setOpenFeedbackDialog(false);
        setEditingReview(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting review:', error);
    } finally {
      setIsLoadingReview(false);
    }
  };


  const handleViewDetails = (appointment) => {
    setSelectedAppointment(appointment);
    setOpenFeedbackDialog(true);
    setFeedbackTab(0);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setActiveFilter(null); // Reset filter when switching tabs
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, finalFilteredAppointments.length - page * rowsPerPage);



  const APPOINTMENT_TABS = [
    {
      value: "upcoming",
      label: "Upcoming",
      icon: <CalendarMonthIcon />,
    },
    {
      value: "scheduled",
      label: "Scheduled",
      icon: <AccessTimeIcon />,
    },
    {
      value: "pending-feedback",
      label: "Pending Feedback",
      icon: <StarIcon />,
    },
      {
        value: "completed",
        label: "Completed",
        icon: <CheckCircle />,
      },
      {
        value: "cancelled",
        label: "Cancelled",
        icon: <Cancel />,
      },

  ];

  const selectedTab =
    APPOINTMENT_TABS.find(
      (tab) => tab.value === (activeFilter ?? "upcoming")
    ) ?? APPOINTMENT_TABS[0];

  const getEffectiveStatus = (appointment) => {
  if (appointment.status.toLowerCase() !== 'scheduled') {
    return appointment.status;
  }
  if (!appointment.date || !appointment.time) {
    return appointment.status;
  }

  // appointment.time is "HH:MM - HH:MM" (24-hour, start - end)
  const [, endTimeRaw] = appointment.time.split(' - ');
  if (!endTimeRaw) return appointment.status;

  const [hours, minutes] = endTimeRaw.split(':').map(Number);

  const appointmentDateTime = new Date(appointment.date);
  appointmentDateTime.setHours(hours, minutes, 0, 0);

  const now = new Date();

  if (appointmentDateTime < now) {
    return 'not attended';
  }

  return appointment.status;
};

  const isFutureAppointment = (appointment) => {
    const { slot_date, start_time, status } = appointment;
    if (!slot_date || !start_time) {
      console.warn("Missing slot_date or start_time:", appointment);
      return false;
    }

    const slotDateTime = new Date(`${slot_date.split("T")[0]}T${start_time}`);
    const now = new Date();

    const future = slotDateTime > now && status.toLowerCase() === "scheduled";

    console.log(
      `Appointment ID: ${appointment.id}, Status: ${status}, Slot: ${slotDateTime}, Now: ${now}, Render Delete: ${future}`
    );

    return future;
  };


//starting an IVR call for audio consultations or opening the meeting link for video consultations
const handleConsultationClick = async (e, appointment) => {
  e.stopPropagation();

  if (!isModeEnabled(appointment)) return;

  try {
    if (appointment.type?.toLowerCase() === 'audio') {
      await initiateIVRCall(
        appointment.doctor_id,
        appointment.customer_id
      );
    }

    if (
      appointment.type?.toLowerCase() === 'video' &&
      appointment.meetLink
    ) {
      window.open(appointment.meetLink, '_blank');
    }
  } catch (err) {
    console.error('Failed to start consultation', err);
  }
};

const handleCopyMeetLink = async (e, appointment) => {
    e.stopPropagation();

    const meetLink = appointment?.meetLink;

    if (!meetLink) {
      console.warn("No meet link available");
      return false;
    }

    try {
      // Modern browsers / HTTPS / localhost
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(meetLink);
        console.log("Meet link copied:", meetLink);
        return true;
      }

      // Fallback for local HTTP/IP environments
      const textArea = document.createElement("textarea");
      textArea.value = meetLink;

      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";
      textArea.style.top = "-9999px";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");

      document.body.removeChild(textArea);

      if (successful) {
        console.log("Meet link copied using fallback:", meetLink);
        return true;
      }

      throw new Error("Copy command failed");
    } catch (error) {
      console.error("Failed to copy meet link:", error);
      return false;
    }
  };
//isModeEnabled() mainly handles the 7 AM → end time clickability 
const isModeEnabled = (appointment) => {
  const now = new Date();
  const appointmentDate = appointment.rawDate.split("T")[0];

  const [startTime, endTime] = appointment.time.split(" - ");
  const appointmentStart = new Date(`${appointmentDate}T${startTime}:00`);
  const appointmentEnd = new Date(`${appointmentDate}T${endTime}:00`);

  // e.g. allow joining up to 10 minutes early
  const joinWindowStart = new Date(appointmentStart.getTime() - 10 * 60 * 1000);

  return now >= joinWindowStart && now <= appointmentEnd;
};

// hides chip after appointment end time
const shouldShowModeChip = (appointment) => {
    if (appointment.status?.toLowerCase() !== "scheduled") {
      return false;
    }
    const now = new Date();

    const appointmentDate = appointment.rawDate.split("T")[0];

    const endTime = appointment.time.split(" - ")[1];
    const appointmentEnd = new Date(`${appointmentDate}T${endTime}:00`);

    return now <= appointmentEnd;
  };
  const showModeColumn = finalFilteredAppointments.some(
    (appointment) => shouldShowModeChip(appointment)
  );
  return (
    <Box sx={[{
      flexGrow: 1,
      p: { xs: 1, sm: 2, md: 3 },
      maxWidth: '100%',
      overflowX: 'hidden',
      fontFamily: theme.typography.fontFamily,
      background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
    }, typographyStyles]}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1.5}
        mb={3}
      >

        <Typography variant="h6" sx={{ fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
          My Appointments
        </Typography>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: '#F0F5FF',
            width: 40,
            height: 40,
            borderRadius: '50%',
            color: '#0B2D6B',
            '&:hover': {
              backgroundColor: '#E0EBFF'
            }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      </Stack>

      <Stack
        spacing={3}
        sx={{ mb: { xs: 2, sm: 3 }, px: { xs: 1, sm: 2, md: 3 }, pt: 2 }}
      >
        <Box sx={{ borderColor: "divider", mb: 2, display: "flex", justifyContent: "space-between", background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)', }}>

          <Tabs
            value={activeFilter ?? "upcoming"} // ✅ reuse existing state
            onChange={(_, newValue) => {
              console.log("Tab clicked:", newValue);

              // 🔁 SAME logic as Box onClick
              if (newValue === "upcoming") {
                setActiveTab(0);
                setActiveFilter(null);
              } else if (newValue === "scheduled") {
                setActiveTab(1);
                setActiveFilter("scheduled");
              } else if (newValue === "pending-feedback") {
                setActiveTab(1);
                setActiveFilter("pending-feedback");
              } else if (newValue === "completed") {
                setActiveTab(1);
                setActiveFilter("completed");
              }
              else if (newValue === "cancelled") {
                setActiveTab(1);
                setActiveFilter("cancelled");
              }

              setPage(0);
            }}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons={isMobile ? "auto" : false}
            allowScrollButtonsMobile
            textColor="primary"
            indicatorColor="primary"
            sx={{
              width: '100%',
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.9rem" },
                minHeight: 48,
                minWidth: { xs: 'auto', sm: 90 },
                px: { xs: 1, sm: 2 },
              },
              "& .MuiTab-wrapper": {
                flexDirection: "row",
                gap: 1,
              },
            }}
          >

            <Tab
              value="upcoming"
              icon={<CalendarMonthIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={isMobile ? `Upcoming (${upcomingAppointments.length})` : `Upcoming (${upcomingAppointments.length})`}
            />

            <Tab
              value="scheduled"
              icon={<AccessTimeIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={isMobile ? `Scheduled (${scheduledAppointments.length})` : `Scheduled (${scheduledAppointments.length})`}
            />

            <Tab
              value="pending-feedback"
              icon={<StarIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={isMobile ? `Feedback (${pastAppointments.filter(appt => !reviews[appt.id] && (appt.status?.toLowerCase().trim() === 'booked' || appt.status?.toLowerCase().trim() === 'completed')).length})` : `Pending Feedback (${pastAppointments.filter(appt => !reviews[appt.id] && (appt.status?.toLowerCase().trim() === 'booked' || appt.status?.toLowerCase().trim() === 'completed')).length})`}
            />

              <Tab
                value="completed"
                icon={<CheckCircle sx={{ fontSize: "1.1rem" }} />}
                iconPosition="start"
                label={isMobile ? `Done (${pastAppointments.filter(appt => reviews[appt.id]).length})` : `Completed (${pastAppointments.filter(appt => reviews[appt.id]).length})`}
              />

               <Tab
                value="cancelled"
                icon={<Cancel sx={{ fontSize: "1.1rem" }} />}
                iconPosition="start"
                label={isMobile ? `Cancelled (${appointments.filter(appt => appt.status?.toLowerCase() === "cancelled").length})` : `Cancelled (${appointments.filter(appt => appt.status?.toLowerCase() === "cancelled").length})`}
              />
          
            </Tabs>

        </Box>

        <Box sx={{ width: '100%', maxWidth: 300, }}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Search appointments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              sx: {
                height: 36,
                '& input': {
                  py: 0.5,
                }
              }
            }}

            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                backgroundColor: 'background.paper',
              },
            }}
          />
        </Box>
       

        {/* Appointments Table */}
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              width: '100%',
              overflow: 'hidden',
              p: { xs: 1, sm: 2 },
              fontFamily: 'inherit',
              borderRadius: 3,
              bgcolor: 'white',
              border: '1px solid #e0e0e0',
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5} mb={2}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  '& svg': {
                    fontSize: '1.4rem',
                  },
                  color: '#22c55e'
                }}
              >
                {selectedTab.icon}
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  lineHeight: 1,
                  fontSize: '1.1rem',
                  background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'
                }}
              >
                {selectedTab.label} Appointments
              </Typography>
            </Box>
            

            <TableContainer
              sx={{
                maxHeight: { xs: 'calc(100vh - 300px)', sm: 'none' },
                overflowX: 'auto',
                '&::-webkit-scrollbar': {
                  height: 6,
                  width: 6,
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'text.disabled',
                  borderRadius: 3,
                },
                '& .MuiTable-root': {
                  minWidth: 900,
                  '& .MuiTableCell-root': {
                    fontSize: { xs: '0.7rem', sm: '0.875rem' },
                    padding: { xs: '6px 8px', sm: '16px' },
                    whiteSpace: 'nowrap',
                  }
                }
              }}
            >
              <Table size={isMobile ? 'small' : 'medium'}>
                <TableHead>
                   <TableRow sx={{
                    background: 'linear-gradient(to bottom, #f4f4f4, #f9f9f9)', // very light shade
                  }}>
                    <TableCell>Doctor</TableCell>
                    <TableCell >Consulting For</TableCell>
                    <TableCell>Specialty</TableCell>
                    <TableCell>Date & Time</TableCell>
                    {/* <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>Type</TableCell> */}
                    <TableCell >Status</TableCell>
                    {activeFilter !== 'cancelled' && <TableCell>Actions</TableCell>}
                   {showModeColumn && (
                      <TableCell>Mode</TableCell>
                    )}
                    {activeFilter === 'cancelled' && (
                      <TableCell>Cancellation Details</TableCell>
                    )}
                     {/* sx={{ display: { xs: 'none', sm: 'table-cell' } }} */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {finalFilteredAppointments.length > 0 ? (
                    finalFilteredAppointments
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((appointment) => (
                        <TableRow key={appointment.id} sx={{ bgcolor: 'white', }}>
                          <TableCell>
                            <Stack direction="row" alignItems="center" spacing={1}>

                              <Box display="flex" alignItems="center" gap={2}>
                                <Avatar sx={{ bgcolor: 'primary.main' }}>
                                  {appointment.doctorName ? appointment.doctorName.charAt(0).toUpperCase() : '?'}
                                </Avatar>
                              </Box>
                              <Box sx={{ minWidth: 0, flex: 1 }}>
                                <Typography
                                  variant={isMobile ? 'body2' : 'body1'}
                                  noWrap
                                  sx={{ fontWeight: isMobile ? 500 : 'normal' }}
                                >
                                  {appointment.doctorName}
                                </Typography>
                                {/* Show additional info on mobile when columns are hidden */}
                                {/* {isMobile && (
                                  <Box sx={{ mt: 0.5 }}>
                                    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.5 }}>
                                      <Typography variant="caption" sx={{ fontWeight: 500 }}>
                                        {appointment.customerName}
                                      </Typography>
                                      <Chip
                                        label={appointment.consultingFor}
                                        size="small"
                                        sx={{
                                          height: 16,
                                          backgroundColor: appointment.consultingFor === 'Self' ? '#e3f2fd' : '#fff3e0',
                                          color: appointment.consultingFor === 'Self' ? '#1976d2' : '#f57c00',
                                          border: appointment.consultingFor === 'Self' ? '1px solid #1976d2' : '1px solid #f57c00',
                                          '& .MuiChip-label': {
                                            px: 0.5,
                                            fontSize: '0.6rem',
                                            fontWeight: 500,
                                          },
                                        }}
                                      />
                                    </Stack>
                                    <Typography variant="caption" color="text.secondary" display="block">
                                      {appointment.specialty}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" display="block">
                                      {appointment.date} • {formatSlotToAMPM(appointment.time)}
                                    </Typography>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
                                      {getTypeIcon(appointment.type)}
                                      <Typography variant="caption" color="text.secondary">
                                        {appointment.type.toLowerCase() === 'video'
                                          ? 'Video Consultation'
                                          : appointment.type.toLowerCase() === 'phone'
                                            ? 'Phone Call'
                                            : appointment.type}
                                      </Typography>
                                      <Chip
                                        label={
                                          getEffectiveStatus(appointment)
                                            .split(' ')
                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                            .join(' ')
                                        }
                                        size="small"
                                        sx={{
                                          height: 20,
                                          backgroundColor: 'transparent',
                                          border: (() => {
                                            const lowerStatus = getEffectiveStatus(appointment).toLowerCase();
                                            return lowerStatus === 'completed'
                                              ? '1px solid green'
                                              : lowerStatus === 'scheduled'
                                                ? '1px solid blue'
                                                : lowerStatus === 'not attended'
                                                  ? '1px solid #d32f2f'
                                                  : lowerStatus === 'cancelled'
                                                    ? '1px solid red'
                                                    : undefined;
                                          })(),
                                          '& .MuiChip-label': {
                                            px: 0.5,
                                            fontSize: '0.65rem',
                                            color: (() => {
                                              const lowerStatus = getEffectiveStatus(appointment).toLowerCase();
                                              return lowerStatus === 'completed'
                                                ? 'green'
                                                : lowerStatus === 'scheduled'
                                                  ? 'blue'
                                                  : lowerStatus === 'not attended'
                                                    ? '#d32f2f'
                                                    : lowerStatus === 'cancelled'
                                                      ? 'red'
                                                      : undefined;
                                            })(),
                                          },
                                        }}
                                      />
                                    </Stack>
                                    
                                  </Box>
                                )} */}
                              </Box>
                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                {appointment.customerName}
                              </Typography>
                              <Chip
                                label={appointment.consultingFor}
                                size="small"
                                sx={{
                                  height: 20,
                                  backgroundColor: appointment.consultingFor === 'Self' ? '#e3f2fd' : '#fff3e0',
                                  color: appointment.consultingFor === 'Self' ? '#1976d2' : '#f57c00',
                                  border: appointment.consultingFor === 'Self' ? '1px solid #1976d2' : '1px solid #f57c00',
                                  '& .MuiChip-label': {
                                    px: 1,
                                    fontSize: '0.7rem',
                                    fontWeight: 500,
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Typography variant={isMobile ? 'caption' : 'body2'}>
                              {appointment.specialty}
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Box>
                              <Typography variant={isMobile ? 'caption' : 'body2'}>
                                {appointment.date}
                              </Typography>
                              <Typography variant="caption" color="text.secondary" display="block">
                                {formatSlotToAMPM(appointment.time)}
                              </Typography>
                            </Box>
                          </TableCell>
                          {/* <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>
                            <Stack direction="row" alignItems="center" spacing={0.5}>
                              {getTypeIcon(appointment.type)}
                              <Typography variant={isMobile ? 'caption' : 'body2'}>
                                {appointment.type.toLowerCase() === 'video'
                                  ? 'Video Consultation'
                                  : appointment.type.toLowerCase() === 'phone'
                                    ? 'Phone Call'
                                    : appointment.type}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                          <TableCell>
                       
                            {(() => {
                              const effectiveStatus = getEffectiveStatus(appointment);
                              const lowerStatus = effectiveStatus.toLowerCase();

                              return (
                                <Chip
                                  label={
                                    effectiveStatus
                                      .split(' ')
                                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                      .join(' ')
                                  }
                                  size={isMobile ? 'small' : 'medium'}
                                  sx={{
                                    backgroundColor: 'transparent',
                                    border:
                                      lowerStatus === 'completed'
                                        ? '1px solid green'
                                        : lowerStatus === 'scheduled'
                                          ? '1px solid blue'
                                          : lowerStatus === 'not attended'
                                            ? '1px solid #d32f2f'
                                            : lowerStatus === 'cancelled'
                                              ? '1px solid red'
                                              : undefined,
                                    color:
                                      lowerStatus === 'completed'
                                        ? 'green'
                                        : lowerStatus === 'scheduled'
                                          ? 'blue'
                                          : lowerStatus === 'not attended'
                                            ? '#d32f2f'
                                            : lowerStatus === 'cancelled'
                                              ? 'red'
                                              : undefined,
                                    '& .MuiChip-label': {
                                      px: { xs: 0.5, sm: 1 },
                                      fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                      color:
                                        lowerStatus === 'completed'
                                          ? 'green'
                                          : lowerStatus === 'scheduled'
                                            ? 'blue'
                                            : lowerStatus === 'not attended'
                                              ? '#d32f2f'
                                              : lowerStatus === 'cancelled'
                                                ? 'red'
                                                : undefined,
                                    },
                                    borderRadius: 1,
                                  }}
                                />
                              );
                            })()}


                          </TableCell>
                          

                        {activeFilter !== 'cancelled' && (
                            <TableCell>
                              <Stack
                                direction="row"
                                spacing={0.5}
                                justifyContent="flex-start"
                                flexWrap="wrap"
                                useFlexGap
                              >
                                {reviews[appointment.id] && (
                                  <Button
                                    size="small"
                                    startIcon={isMobile ? null : <Eye />}
                                    onClick={() => handleViewDetails(appointment)}
                                    sx={{
                                      minWidth: 'auto',
                                      p: isMobile ? 0.5 : 1,
                                      '& .MuiButton-startIcon': {
                                        mr: isMobile ? 0 : 0.5
                                      }
                                    }}
                                  >
                                    {isMobile ? <Eye fontSize="small" /> : 'View'}
                                  </Button>
                                )}
                                {appointment.status === 'completed' && (
                                  <>
                                    <Button
                                      size="small"
                                      color="warning"
                                      startIcon={<StarIcon />}
                                      onClick={() => handleEditReview(appointment)}
                                      disabled={isLoadingReview}
                                    >
                                      {reviews[appointment.id] ? 'Edit Review' : 'Review'}
                                    </Button>

                                  </>
                                )}

                                {(() => {
                                  const endTime = appointment.time.split(" - ")[1];
                                  const appointmentEndDateTime = new Date(`${appointment.rawDate.split("T")[0]}T${endTime}`);
                                  const isPastAppointment = appointmentEndDateTime < new Date();

                                  const canCancel =
                                    appointment.status === "scheduled" &&
                                    !isPastAppointment &&
                                    isMoreThan2HoursBefore(appointment.startTime, appointment.rawDate);

                                  return canCancel ? (
                                    <Chip
                                      label="Cancel"
                                      size={isMobile ? 'small' : 'medium'}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleCancelClick(appointment);
                                      }}
                                      sx={{
                                        backgroundColor: 'transparent',
                                        border: '1px solid red',
                                        color: 'red',
                                        '& .MuiChip-label': {
                                          px: { xs: 0.5, sm: 1 },
                                          fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                          color: 'red',
                                        },
                                        borderRadius: 1,
                                        cursor: 'pointer',
                                        '&:hover': {
                                          backgroundColor: 'rgba(255, 0, 0, 0.04)',
                                        },
                                      }}
                                    />
                                  ) : (
                                    <Chip
                                      label="Cancel"
                                      size={isMobile ? 'small' : 'medium'}
                                      disabled={isPastAppointment}
                                      onClick={(e) => {
                                        if (!isPastAppointment) {
                                          e.stopPropagation();
                                          handleCancelClick(appointment);
                                        }
                                      }}
                                      sx={{
                                        backgroundColor: 'transparent',
                                        border: isPastAppointment ? '1px solid #ccc' : '1px solid red',
                                        color: isPastAppointment ? '#999' : 'red',
                                        '& .MuiChip-label': {
                                          px: { xs: 0.5, sm: 1 },
                                          fontSize: { xs: '0.65rem', sm: '0.75rem' },
                                          color: isPastAppointment ? '#999' : 'red',
                                        },
                                        borderRadius: 1,
                                        cursor: isPastAppointment ? 'not-allowed' : 'pointer',
                                        '&:hover': !isPastAppointment ? {
                                          backgroundColor: 'rgba(255, 0, 0, 0.04)',
                                        } : {},
                                      }}
                                    />
                                  );
                                })()}

                              </Stack>
                            </TableCell>
                          )}
                          
{showModeColumn && (

                            <TableCell>
                              <Stack direction="row" spacing={0.5} alignItems="center">
                                {shouldShowModeChip(appointment) && (
                                  <Chip
                                    // icon={
                                    //   appointment.type?.toLowerCase() === 'video' ? (
                                    //     <VideoCallIcon sx={{ fontSize: 16 }} />
                                    //   ) : (
                                    //     <PhoneIcon sx={{ fontSize: 16 }} />
                                    //   )
                                    // }
                                    // label={appointment.type?.replace(/\b\w/g, c => c.toUpperCase())}
                                    label={
                                      appointment.type?.toLowerCase() === 'video'
                                        ? 'Join Session'
                                        : 'Initiate Call'
                                    }
                                    size="small"
                                    disabled={!isModeEnabled(appointment)}
                                    onClick={(e) => {
                                      console.log("Video chip clicked", appointment);
                                      handleConsultationClick(e, appointment)
                                    }}
                                    sx={{
                                      fontSize: '0.7rem',
                                      fontWeight: 600,
                                      height: 32,
                                      borderRadius: 1,
                                      backgroundColor:
                                        appointment.type?.toLowerCase() === 'video'
                                          ? '#E0E7FF'
                                          : '#DCFCE7',
                                      color:
                                        appointment.type?.toLowerCase() === 'video'
                                          ? '#4338CA'
                                          : '#15803D',
                                      border:
                                        appointment.type?.toLowerCase() === 'video'
                                          ? '1px solid #A5B4FC'
                                          : '1px solid #86EFAC',
                                      '& .MuiChip-icon': { color: 'inherit' },
                                      '&:hover': {
                                        backgroundColor:
                                          appointment.type?.toLowerCase() === 'video'
                                            ? '#E0E7FF'
                                            : '#DCFCE7',
                                      },
                                    }}
                                  />
                                )}

                                {shouldShowModeChip(appointment) &&
                                  isModeEnabled(appointment) &&
                                  appointment.type?.toLowerCase() === 'video' &&
                                  appointment.meetLink && (
                                    <Tooltip
                                      title={copiedAppointmentId === appointment.id ? 'Copied!' : 'Copy link'}
                                      arrow
                                    >
                                      <IconButton
                                        size="small"
                                        onClick={async (e) => {
                                          await handleCopyMeetLink(e, appointment);
                                          setCopiedAppointmentId(appointment.id);
                                          setTimeout(() => {
                                            setCopiedAppointmentId(null);
                                          }, 2000);
                                        }}
                                        sx={{
                                          width: 30,
                                          height: 30,
                                          color: '#555',
                                          border: '1px solid #D1D5DB',
                                          borderRadius: 1,
                                          backgroundColor:
                                            copiedAppointmentId === appointment.id ? '#DCFCE7' : '#F5F5F5',
                                          '&:hover': {
                                            backgroundColor:
                                              copiedAppointmentId === appointment.id ? '#DCFCE7' : '#EEEEEE',
                                          },
                                        }}
                                      >
                                        <ContentCopyIcon sx={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </Stack>
                            </TableCell>
                          )}
                          {activeFilter === "cancelled" && (
                            <TableCell>
                              <Stack spacing={0.5}>

                                {/* Cancelled date/time */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      fontWeight: 600,
                                      // color: "error.main",
                                    }}
                                  >
                                    Cancelled at:
                                  </Box>{" "}
                                  {formatCancelledAt(appointment.cancelledAt) || "-"}
                                </Typography>

                                {/* Cancelled by */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      fontWeight: 600,
                                    }}
                                  >
                                    Cancelled by:
                                  </Box>{" "}
                                  {["echoshine", "echobuddy"].includes(
                                    appointment.cancellationTriggeredBy?.toLowerCase()
                                  )
                                    ? "User"
                                    : appointment.cancellationTriggeredBy?.toLowerCase() ===
                                      "counsellor"
                                      ? "Counsellor"
                                      : appointment.cancellationTriggeredBy || "-"}
                                </Typography>

                                {/* Remark */}
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  <Box
                                    component="span"
                                    sx={{
                                      fontWeight: 600,
                                    }}
                                  >
                                    Remark:
                                  </Box>{" "}
                                  {appointment.cancellationRemark || "-"}
                                </Typography>

                              </Stack>
                            </TableCell>
                          )}



                        </TableRow>
                      ))) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        <Typography variant="body2" color="text.secondary">
                          No appointments available.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={finalFilteredAppointments.length}
              rowsPerPage={rowsPerPage}
              sx={{
                '& .MuiTablePagination-toolbar': {
                  flexWrap: 'wrap',
                  gap: 1,
                  '& > *': {
                    my: 0.5
                  }
                },
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                  my: 0
                }
              }}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

          </Paper>
        </Grid>
      </Stack>

      {/* Appointment Details Dialog */}
      <Dialog
        open={openFeedbackDialog}
        onClose={() => setOpenFeedbackDialog(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        scroll="body"
        PaperProps={{
          sx: {
            fontFamily: theme.typography.fontFamily,
          }
        }}
        sx={{
          '& .MuiDialog-paper': {
            m: 0,
            width: '100%',
            maxHeight: '100%',
            '&.MuiDialog-paperFullScreen': {
              height: '100%',
              m: 0,
              borderRadius: 0
            }
          },
          '& .MuiDialogContent-root': {
            p: { xs: 2, sm: 3 },
            '&:first-of-type': {
              pt: { xs: 3, sm: 4 }
            }
          },
          '& .MuiDialogTitle-root': {
            p: { xs: 2, sm: 2 },
            pb: { xs: 1, sm: 2 },
            borderBottom: '1px solid',
            borderColor: 'divider'
          },
          '& .MuiDialogActions-root': {
            p: { xs: 2, sm: 1 },
            pt: 1,
            borderTop: '1px solid',
            borderColor: 'divider',
            '&.MuiDialogActions-spacing > :not(:first-of-type)': {
              ml: 1.5
            }
          }
        }}
      >
        <DialogTitle>
          <Stack direction="row" alignItems="center" spacing={1}>
            {isMobile && (
              <IconButton
                edge="start"
                onClick={() => setOpenFeedbackDialog(false)}
                sx={{ mr: 0.5, ml: -1 }}
              >
                <ArrowLeft />
              </IconButton>
            )}
            <Typography variant="h6" component="div" sx={{ flex: 1 }}>
              {feedbackTab === 0 ? 'Appointment Details' : 'Leave Feedback'}
            </Typography>
            {!isMobile && (
              <IconButton
                edge="end"
                onClick={() => setOpenFeedbackDialog(false)}
                sx={{ mr: -1 }}
              >
                <X />
              </IconButton>
            )}
          </Stack>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            '&:first-of-type': {
              paddingTop: '10px !important',
            },
          }}
        >
          <Tabs
            value={feedbackTab}
            onChange={(e, newValue) => setFeedbackTab(newValue)}
            variant="fullWidth" // each tab takes equal width
            sx={{
              mb: 2,
              '& .MuiTabs-flexContainer': {
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '1px',
                  bgcolor: (theme) => theme.palette.divider,
                },
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 500,
                minHeight: 48,
                '&.Mui-selected': {
                  color: (theme) => theme.palette.primary.main,
                },
                '&:not(:last-child)::after': {
                  content: '""',
                  position: 'absolute',
                  right: 0,
                  height: '95%',
                  width: '1px',
                  bgcolor: (theme) => theme.palette.primary.main,
                },
              },
            }}
          >
            <Tab label="Summary" />
            {selectedAppointment?.status === 'completed' && (
              <Tab label="Feedback" />
            )}
          </Tabs>

          {feedbackTab === 0 && selectedAppointment && (
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={6}>
                <Stack spacing={2}>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Doctor</Typography>
                    <Typography>
                      {selectedAppointment.doctorName}
                      {selectedAppointment.specialty && ` (${selectedAppointment.specialty})`}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Date & Time</Typography>
                    <Typography>{selectedAppointment.date} at {formatSlotToAMPM(selectedAppointment.time)}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Status</Typography>
                    <Chip
                      label={selectedAppointment.status.charAt(0).toUpperCase() + selectedAppointment.status.slice(1).toLowerCase()}
                      size={isMobile ? 'small' : 'medium'}
                      sx={{
                        backgroundColor: 'transparent', // ✅ remove gray background
                        border: selectedAppointment.status.toLowerCase() === 'scheduled' ? '1px solid green' : undefined,
                        color: selectedAppointment.status.toLowerCase() === 'scheduled' ? 'green' : undefined,
                        '& .MuiChip-label': {
                          px: { xs: 0.5, sm: 1 },
                          fontSize: { xs: '0.65rem', sm: '0.75rem' },
                          color: selectedAppointment.status.toLowerCase() === 'scheduled' ? 'green' : undefined,
                        },
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Type</Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                      {getTypeIcon(selectedAppointment.type)}
                      <span>
                        {selectedAppointment.type.toLowerCase() === 'video'
                          ? 'Video Consultation'
                          : selectedAppointment.type.toLowerCase() === 'phone'
                            ? 'Phone Call'
                            : selectedAppointment.type}
                      </span>
                    </Stack>
                  </Box>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">Location/Details</Typography>
                    <Typography>{selectedAppointment.location || 'N/A'}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {selectedAppointment.phone}
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              {selectedAppointment.sessionNotes && (
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>Session Notes</Typography>
                  <Paper variant="outlined" sx={{ p: 2, minHeight: 200 }}>
                    <Typography>{selectedAppointment.sessionNotes}</Typography>
                  </Paper>
                </Grid>
              )}
            </Grid>
          )}

          {feedbackTab === 1 && selectedAppointment && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>How was your experience?</Typography>
                <Box sx={{ mb: 3 }}>
                  <Typography gutterBottom>Rate your experience</Typography>
                  <StyledRating
                    name="rating"
                    value={rating}
                    onChange={(event, newValue) => setRating(newValue)}
                    emptyIcon={<StarBorderIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                  />
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography gutterBottom>What made your experience great?</Typography>
                  <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    mb: 2,
                    '& > *': {
                      m: '2px !important',
                      '&:first-of-type': {
                        ml: '0 !important'
                      }
                    }
                  }}>
                    {feedbackTagOptions.map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        onClick={() => handleFeedbackTagToggle(tag)}
                        color={feedbackTags.includes(tag) ? 'primary' : 'default'}
                        variant={feedbackTags.includes(tag) ? 'filled' : 'outlined'}
                      />
                    ))}
                  </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                  <Typography gutterBottom>Additional comments (optional)</Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Share more about your experience..."
                    value={review}
                    onChange={(e) => setReview(e.target.value)}
                  />
                </Box>

                <Box>
                  <Typography gutterBottom>Would you recommend this doctor?</Typography>
                  <Stack direction="row" spacing={2}>
                    <Button
                      size="small"
                      variant={recommend === 'yes' ? 'contained' : 'outlined'}
                      color="success"
                      startIcon={<ThumbUpIcon />}
                      onClick={() => setRecommend('yes')}
                      sx={{ px: 1.5, py: 0.5, fontSize: '0.75rem' }}
                    >
                      Yes
                    </Button>
                    <Button
                      size="small"
                      variant={recommend === 'no' ? 'contained' : 'outlined'}
                      color="error"
                      onClick={() => setRecommend('no')}
                      sx={{ px: 1.5, py: 0.5, fontSize: '0.75rem' }}
                    >
                      No
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'flex-end', // align buttons to the right
            position: isMobile ? 'sticky' : 'static',
            bottom: 0,
            bgcolor: 'background.paper',
            zIndex: 1,
            gap: 1, // spacing between buttons
            '& .MuiButton-root': {
              width: isMobile ? '100%' : '150px', // full width on mobile, fixed on desktop
            },
          }}
        >
          <Button onClick={() => setOpenFeedbackDialog(false)}>Close</Button>
          {feedbackTab === 1 && (
            <Button
              variant="contained"
              onClick={handleSubmitFeedback}
              disabled={!rating || !recommend}
            >
              Submit Feedback
            </Button>
          )}
        </DialogActions>

      </Dialog>

      {/* Snackbar for showing messages */}
      <Snackbar
        open={showSnackbar.open}
        autoHideDuration={6000}
        onClose={() => setShowSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setShowSnackbar(prev => ({ ...prev, open: false }))}
          severity={showSnackbar.severity || 'success'}
          sx={{ width: '100%' }}
        >
          {showSnackbar.message}
        </Alert>
      </Snackbar>

      <Dialog
  open={cancelDialogOpen}
  onClose={handleCancelDialogClose}
  maxWidth="sm"
  fullWidth
>
  {canCancel ? (
    <>
      <DialogTitle>Cancel Appointment</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to cancel this appointment? This action cannot be undone.
        </Typography>
        <TextField
          label="Cancellation Remark"
          placeholder="Please provide a reason for cancellation…"
          multiline
          rows={3}
          fullWidth
          required
          value={cancelRemark}
          onChange={(e) => setCancelRemark(e.target.value)}
          size="small"
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelDialogClose}>No, Keep It</Button>
        <Button
          onClick={handleConfirmCancel}
          variant="contained"
          color="error"
          disabled={!cancelRemark.trim()}
        >
          Yes, Cancel
        </Button>
      </DialogActions>
    </>
  ) : (
    <>
      <DialogTitle
        sx={{
          fontSize: "1.25rem",
          fontWeight: 600,
          pb: 1
        }}
      >
        Unable to Cancel Appointment
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.6 }}
        >
          Appointments can only be cancelled more than{" "}
          <strong>2 hours</strong> before the scheduled start time.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleCancelDialogClose}
          sx={{ minWidth: 90 }}
        >
          OK
        </Button>
      </DialogActions>
    </>
  )}
</Dialog>
    </Box >
  );
};

export default MyAppointments;
